export default {
    items: [],
    permissions: [],
    active: [],
    perPage: 5,
    page: 1,
    // active: 0,
    // inactive: 0,
    total: 0,
}
